import router from './index'
import store from '../store/index'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import ElementUI from 'element-ui'
import { GetToken } from '@/utils/cookies/index'

//白名单
const whiteList = ['Login', 'Sign']
router.beforeEach((to, from, next) => {
  let { name, path, meta } = to
  NProgress.start()
  if (GetToken()) {
    if (name == 'Login')
      return next({
        name: 'Home'
      })
    return next()
  }
  //如果目标存在于白名单，则不处理拦截
  if(name && whiteList.indexOf(name) != -1)
    return next()
  return next({
    name: 'Login', 
    query: { 
      redirect: path 
    }
  })
})
router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/router/permission.js